import React, { useState, useCallback } from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface SportsGridProps {
  sports: string[];
  onSportClick: (sport: string) => void;
  className?: string;
  disabled?: boolean;
}

const SportsGrid: React.FC<SportsGridProps> = ({
  sports,
  onSportClick,
  className,
  disabled = false
}) => {
  return (
    <div className={cn("flex flex-wrap gap-2 justify-center", className)}>
      {sports.map((sport, index) => {
        const [emoji, ...nameParts] = sport.split(' ');
        const name = nameParts.join(' ');
        
        return (
          <button
            key={index}
            onClick={() => onSportClick(sport)}
            disabled={disabled}
            className={cn(
              "flex items-center px-3 py-1.5 rounded-full text-sm",
              "transition-colors duration-200",
              disabled 
                ? "bg-gray-400 text-dark-50 opacity-50 cursor-not-allowed" 
                : "bg-dark-300 text-white hover:bg-dark-400",
              "transform hover:scale-105 active:scale-95"
            )}
          >
            <span className="mr-1.5">{emoji}</span>
            <span>{name}</span>
          </button>
        );
      })}
    </div>
  );
};

export default SportsGrid;